"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsService = void 0;
class SettingsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV3WorkspacesTrialModesSettings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v3/workspaces/trial/modes/settings',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.SettingsService = SettingsService;
